module.exports = __webpack_public_path__ + "img/icon-clock.11238d95.svg";